import { axios } from 'configs'
import type {
  TBanStatusChannelListResponse,
  TBanStatusResponse,
  TListBanStatusChannelsRequest,
} from 'types'

const BASE_PATH = '/admin/line-channels/ban-status'

/** 全組織の集計。絞り込みは受け付けない。 */
export const getLineChannelBanStatus = async (): Promise<TBanStatusResponse> => {
  const response = await axios.get<TBanStatusResponse>(BASE_PATH)
  return response.data
}

/**
 * 払い出しできないチャンネルの一覧。
 * 空の値は送らない（バックエンドが空文字を400として弾くため）。
 */
export const listBanStatusChannels = async (
  request: TListBanStatusChannelsRequest = {},
): Promise<TBanStatusChannelListResponse> => {
  const params = Object.fromEntries(
    Object.entries(request).filter(
      ([, value]) => value !== undefined && value !== '',
    ),
  )
  const response = await axios.get<TBanStatusChannelListResponse>(
    `${BASE_PATH}/channels`,
    { params },
  )
  return response.data
}
